import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aa023d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody",
  style: {"max-width":"87vw"}
}
const _hoisted_4 = { class: "D-Flex" }
const _hoisted_5 = {
  key: 0,
  class: "DialogSectionTitle"
}
const _hoisted_6 = { class: "ItemSelector" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "ItemContent" }
const _hoisted_9 = { class: "F-Bold F1_5em" }
const _hoisted_10 = {
  key: 0,
  class: "F-Bold"
}
const _hoisted_11 = { class: "O-50" }
const _hoisted_12 = { class: "F-Bold" }
const _hoisted_13 = { class: "O-50" }
const _hoisted_14 = { class: "F-Bold" }
const _hoisted_15 = { class: "O-50" }
const _hoisted_16 = { class: "F-Bold" }
const _hoisted_17 = { class: "O-50" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "F-Bold F1_25em",
  style: {"color":"var(--colorr1)"}
}
const _hoisted_20 = { class: "O-50" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AddButton" }, "+", -1))
const _hoisted_22 = { class: "W-100 D-Flex" }
const _hoisted_23 = { style: {"margin-inline-start":"1em"} }
const _hoisted_24 = { class: "DialogSectionTitle" }
const _hoisted_25 = { class: "F-Bold F1_5em" }
const _hoisted_26 = { class: "D-Flex" }
const _hoisted_27 = {
  key: 0,
  class: "F-Bold"
}
const _hoisted_28 = { class: "O-50" }
const _hoisted_29 = { class: "F-Bold" }
const _hoisted_30 = { class: "O-50" }
const _hoisted_31 = { class: "F-Bold" }
const _hoisted_32 = { class: "O-50" }
const _hoisted_33 = { class: "F-Bold" }
const _hoisted_34 = { class: "O-50" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "F-Bold F1_25em",
  style: {"color":"var(--colorr1)"}
}
const _hoisted_37 = { class: "O-50" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "scrollpoint",
  class: "CookiesRowSplitter"
}, null, -1))
const _hoisted_39 = { class: "DialogSectionTitle" }
const _hoisted_40 = { class: "DialogSectionTitle" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_42 = {
  class: "DialogSection",
  style: {"width":"70%"}
}
const _hoisted_43 = { class: "DialogSectionTitle" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_47 = { class: "DialogSection" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_49 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_50 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesDropDown = _resolveComponent("CookiesDropDown")!
  const _component_CookiesSearchInput = _resolveComponent("CookiesSearchInput")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.Saving)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.Loading.length > 0)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "DialogSection",
              style: _normalizeStyle([{"width":"60%"}, _ctx.Transfertem ? 'width: 30%': ''])
            }, [
              (!_ctx.Transfertem)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.Translate('Select Item')), 1))
                : _createCommentVNode("", true),
              (!_ctx.Transfertem)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_CookiesDropDown, {
                      Name: _ctx.Translate('Brand'),
                      Width: '40%',
                      style: {"max-width":"80%"},
                      Res: 'D_Transfer_Brand',
                      Options: _ctx.Brands,
                      Type: 'Object',
                      Selector: 'Name'
                    }, null, 8, ["Name", "Options"]),
                    _createVNode(_component_CookiesDropDown, {
                      Name: _ctx.Translate('Category'),
                      Width: '40%',
                      style: {"max-width":"80%"},
                      Res: 'D_Transfer_Category',
                      Options: _ctx.Categories,
                      Type: 'Object',
                      Selector: 'Name'
                    }, null, 8, ["Name", "Options"]),
                    _createVNode(_component_CookiesSearchInput, {
                      Placeholder: _ctx.Translate('Search...'),
                      Res: 'D_Transfer_Search'
                    }, null, 8, ["Placeholder"]),
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredItems, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (_ctx.CheckItem(item)),
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(item.Code), 1),
                            (item.Name && item.Name !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.CashedTranslations['Name']) + ":", 1),
                                  _createTextVNode(),
                                  _createElementVNode("span", null, _toDisplayString(item.Name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.CashedTranslations['Brand']) + ":", 1),
                              _createTextVNode(),
                              _createElementVNode("span", null, _toDisplayString(item.BrandName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.CashedTranslations['Category']) + ":", 1),
                              _createTextVNode(),
                              _createElementVNode("span", null, _toDisplayString(item.CategoryName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.CashedTranslations['Available']) + ":", 1),
                              _createTextVNode(),
                              (item.AvailableQuantity > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.AvailableQuantity), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.CashedTranslations['Not Available']), 1))
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Specifications, (spec) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "F-Bold",
                                key: spec
                              }, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.Translate(spec.Name)) + ":", 1),
                                _createTextVNode(),
                                _createElementVNode("span", null, _toDisplayString(spec.Description), 1)
                              ]))
                            }), 128))
                          ]),
                          _hoisted_21
                        ], 8, _hoisted_7))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.Transfertem)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Transfertem=null, _ctx.MEMWrite('D_Transfer_WarehouseFrom', null),  _ctx.MEMWrite('D_Transfer_WarehouseTo', null))),
                        class: "BG3 Rad3 Shadow1 P1em HoverGlow",
                        style: {"inset-inline-end":"0","padding":"0.5em 0.9em"}
                      }, _toDisplayString(_ctx.Translate('Change')), 1),
                      _createTextVNode(),
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_CookiesIcon, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ShowLocations())),
                          class: "SQR1_5em V-Auto Pointer",
                          ID: ('Search' as IconsIDs)
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.Translate('Item')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.Transfertem.Code), 1),
                      _createElementVNode("div", _hoisted_26, [
                        (_ctx.Transfertem.Name && _ctx.Transfertem.Name !== '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.CashedTranslations['Name']) + ":", 1),
                              _createTextVNode(),
                              _createElementVNode("span", null, _toDisplayString(_ctx.Transfertem.Name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.CashedTranslations['Brand']) + ":", 1),
                          _createTextVNode(),
                          _createElementVNode("span", null, _toDisplayString(_ctx.Transfertem.BrandName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.CashedTranslations['Category']) + ":", 1),
                          _createTextVNode(),
                          _createElementVNode("span", null, _toDisplayString(_ctx.Transfertem.CategoryName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.CashedTranslations['Available']) + ":", 1),
                          _createTextVNode(),
                          (_ctx.Transfertem.AvailableQuantity > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.Transfertem.AvailableQuantity), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.CashedTranslations['Not Available']), 1))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Transfertem.Specifications, (spec) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "F-Bold",
                            key: spec
                          }, [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.Translate(spec.Name)) + ":", 1),
                            _createTextVNode(),
                            _createElementVNode("span", null, _toDisplayString(spec.Description), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_38,
              (_ctx.Transfertem)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.Translate('Select Origin Warehouse')), 1),
                    _createVNode(_component_CookiesDropInputObject, {
                      Name: _ctx.Translate('Warehouse'),
                      Width: '40%',
                      style: {"max-width":"80%"},
                      Res: 'D_Transfer_WarehouseFrom',
                      PreserveMemory: true,
                      Options: _ctx.Warehouses,
                      Type: 'Object',
                      Selectors: ['Code']
                    }, null, 8, ["Name", "Options"])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.Transfertem)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.Translate('Select Destination Warehouse')), 1),
                    _createVNode(_component_CookiesDropInputObject, {
                      Name: _ctx.Translate('Warehouse'),
                      Width: '40%',
                      style: {"max-width":"80%"},
                      Res: 'D_Transfer_WarehouseTo',
                      PreserveMemory: true,
                      Options: _ctx.Warehouses,
                      Type: 'Object',
                      Selectors: ['Code']
                    }, null, 8, ["Name", "Options"])
                  ], 64))
                : _createCommentVNode("", true)
            ], 4),
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.Translate('Select Quantity')), 1),
              (_ctx.Transfertem && _ctx.MEMRead('D_Transfer_WarehouseFrom') && _ctx.MEMRead('D_Transfer_WarehouseTo'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_CookiesTable, {
                      class: "Shadow1",
                      TableSettings: _ctx.TableSettings,
                      CookiesData: _ctx.AvailableItemsLocations
                    }, null, 8, ["TableSettings", "CookiesData"]),
                    _createVNode(_component_CookiesIcon, {
                      style: {"transform":"rotate(90deg)","width":"3em","height":"3em","padding-top":"2em"},
                      ID: ('Arrow' as IconsIDs)
                    }),
                    _createVNode(_component_CookiesTable, {
                      class: "Shadow1",
                      TableSettings: _ctx.ToTableSettings,
                      CookiesData: _ctx.DecodedSections
                    }, null, 8, ["TableSettings", "CookiesData"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_44,
          _hoisted_45,
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Note'),
              Res: 'D_Transfer_Note'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_48
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access('Inventory_Transfers_Export') || _ctx.Access('Inventory_Transfers_Import') || _ctx.Access('Inventory_Transfers_Edit'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1),
            _createElementVNode("button", {
              class: _normalizeClass([_ctx.TotalSense.Status ? '' : 'Disabled', "F-Bold CookiesButton DialogFooterButton"]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.TotalSense.Status ? _ctx.SaveData() : '')),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main)
            }, _toDisplayString(_ctx.Translate('Transfer')), 7)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}